import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  fetchFeatureFlags,
  fetchEnabledFeatures,
  selectFeatureFlags,
  selectEnabledFeatures,
  selectFeatureFlagsLoading,
  selectFeatureFlagsError,
  selectFeatureFlagsInitialized,
  selectIsFeatureEnabled,
} from '../store/slices/featureFlagsSlice';

export const useFeatureFlags = () => {
  const dispatch = useAppDispatch();
  const featureFlags = useAppSelector(selectFeatureFlags);
  const enabledFeatures = useAppSelector(selectEnabledFeatures);
  const loading = useAppSelector(selectFeatureFlagsLoading);
  const error = useAppSelector(selectFeatureFlagsError);
  const initialized = useAppSelector(selectFeatureFlagsInitialized);

  useEffect(() => {
    if (!initialized) {
      dispatch(fetchFeatureFlags());
    }
  }, [dispatch, initialized]);

  const isFeatureEnabled = (key: string): boolean => {
    return enabledFeatures.includes(key);
  };

  const refreshFlags = () => {
    dispatch(fetchFeatureFlags());
  };

  const refreshEnabledFeatures = () => {
    dispatch(fetchEnabledFeatures());
  };

  return {
    featureFlags,
    enabledFeatures,
    loading,
    error,
    initialized,
    isFeatureEnabled,
    refreshFlags,
    refreshEnabledFeatures,
  };
};

export const useFeatureFlag = (key: string) => {
  const isEnabled = useAppSelector(selectIsFeatureEnabled(key));
  
  return isEnabled;
};